import { View } from '@react-pdf/renderer';
import React from 'react';
import { pdfStyles } from '../pdfStyles';
import { ColorSet } from 'src/redux/reducers/theme';

interface IndicatorViewProps {
  children: React.ReactNode;
  colors: ColorSet;
}

export const IndicatorView: React.FC<IndicatorViewProps> = ({ children, colors }) => {
  return (
    <View style={{ ...pdfStyles.section, flexDirection: 'row' }}>
      <View
        style={{
          width: 5,
          backgroundColor: '#ECECEE',
          marginRight: 16,
          borderRadius: 10,
          borderTopLeftRadius: 0,
          overflow: 'hidden',
        }}
      >
        <View
          style={{
            width: '200%',
            height: 36,
            backgroundColor: colors.gp1,
            borderBottomRightRadius: 10,
            borderTopRightRadius: 10,
            left: -5,
          }}
        />
      </View>
      <View style={{ flex: 1, padding: '6px 0' }}>{children}</View>
    </View>
  );
};
